"use client";

import { Share2 } from "lucide-react";
import {
  ShareActionButton,
  shareOrigin,
  type ShareButtonSize,
  type ShareButtonVariant,
} from "@/components/share/ShareActionButton";

interface ShareProductButtonProps {
  productId: string;
  /** Descriptive slug — shared in the URL when present (falls back to id). */
  productSlug?: string | null;
  productTitle: string;
  className?: string;
  variant?: ShareButtonVariant;
  size?: ShareButtonSize;
}

export function ShareProductButton({
  productId,
  productSlug,
  productTitle,
  className,
  variant = "outline",
  size = "sm",
}: ShareProductButtonProps) {
  // Always the canonical /p/[slug] PDP, never the /products?product= drawer URL
  // — a shared drawer link is not crawlable and does not render an OG preview.
  const url = `${shareOrigin()}/p/${encodeURIComponent(productSlug || productId)}`;
  const text = `Check out ${productTitle} from The Floral Muse: ${url}`;

  return (
    <ShareActionButton
      title={productTitle}
      // The native share sheet carries `url` separately, so the text must not
      // repeat it; the clipboard fallback has nowhere else to put it.
      text={`Check out ${productTitle} from The Floral Muse`}
      url={url}
      clipboardText={text}
      copiedMessage="Link copied to clipboard"
      sharedMessage="Shared!"
      ariaLabel="Share product"
      className={className}
      variant={variant}
      size={size}
    >
      <Share2 className="h-4 w-4" />
    </ShareActionButton>
  );
}
